/** Category endpoint calls — content-facing picker options + admin CRUD. */
import type { Category, CategoryAppliesTo, ActiveLanguage } from '@olimhub/shared'
import { apiClient } from '../client'

export interface CategoryInput {
  translations: Record<ActiveLanguage, string>
  parentId?: string | null
  appliesTo?: CategoryAppliesTo[] | null
}

export interface UpdateCategoryInput {
  translations?: Record<ActiveLanguage, string>
  parentId?: string | null
  appliesTo?: CategoryAppliesTo[] | null
  isActive?: boolean
}

export const categoriesApi = {
  // Content-facing — options for the Event/Bazaar/Help/Action/Group category picker.
  getForType: (type: CategoryAppliesTo, language: ActiveLanguage) =>
    apiClient.get<Category[]>('/categories', { params: { type, language } }).then((r) => r.data),

  // Admin management screen — full catalog including inactive categories.
  getAllForAdmin: (language: ActiveLanguage) =>
    apiClient.get<Category[]>('/admin/categories', { params: { language } }).then((r) => r.data),

  create: (body: CategoryInput) =>
    apiClient.post<Category>('/admin/categories', body).then((r) => r.data),

  update: (id: string, body: UpdateCategoryInput) =>
    apiClient.put<Category>(`/admin/categories/${id}`, body).then((r) => r.data),

  delete: (id: string) =>
    apiClient.delete(`/admin/categories/${id}`).then((r) => r.data),
}
